<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <RouterView />
</template>
